import { render, staticRenderFns } from "./ModalWorkCenter.vue?vue&type=template&id=ca4045a6&"
import script from "./ModalWorkCenter.vue?vue&type=script&lang=js&"
export * from "./ModalWorkCenter.vue?vue&type=script&lang=js&"
import style0 from "./ModalWorkCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports